import moment from "moment"
import { inWords, inWords2 } from "../../utils"


export const readyOrderTemplate = (d,) => {
  console.log(d, "Dattt")

  const generateReadyOrderSection = (d) =>
    `
    <div class="order-section">
      <table class="order-table">
        <thead>
          <tr>
            <th colSpan="3">
              Order # : ${d?.code?.substring(0, d?.code?.length - 6)}
            </th>
            <th colSpan="3">
              Party Reference : ${d?.orderDetail?.partyRef ? d?.orderDetail?.partyRef : ''}
            </th>
          </tr>
          <tr>
            <th colSpan="6">
              Party  : ${d?.party?.accountName ? d?.party?.accountName : ''}
            </th>
          </tr>
          <tr>
            <th colSpan="6">
              Product  : ${d?.orderDetail?.product?.productName ? d?.orderDetail?.product?.productName : ''}
            </th>
          </tr>
          <tr class="last">
            <th colSpan="3">
              Quantity: ${d?.orderDetail?.quantity}
            </th>
            <th colSpan="3">
              Date: ${moment(d?.createdAt).format("DD/MM/YY")}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th colSpan="1">SIDE</th>
            <th colSpan="1">SPH</th>
            <th colSpan="1">CYL</th>
            <th colSpan="1">AXIS</th>
            <th colSpan="1">ADD</th>
          </tr>
          <tr>
            <th colSpan="1">R</th>
            <td colSpan="1" style="text-align:center;">${d?.orderDetail?.rSph}</td>
            <td colSpan="1" style="text-align:center;">${d?.orderDetail?.rCyl}</td>
            <td colSpan="1" style="text-align:center;">${d?.orderDetail?.rAxis}</td>
            <td colSpan="1" style="text-align:center;">${d?.orderDetail?.rAddition}</td>
          </tr>
          <tr class="last">
            <th colSpan="1">L</th>
            <td colSpan="1" style="text-align:center;">${d?.orderDetail?.lSph}</td>
            <td colSpan="1" style="text-align:center;">${d?.orderDetail?.lCyl}</td>
            <td colSpan="1" style="text-align:center;">${d?.orderDetail?.lAxis}</td>
            <td colSpan="1" style="text-align:center;">${d?.orderDetail?.lAddition}</td>
          </tr>
          <tr>
            <td colSpan="4">
              <b>Order Note : </b>
              ${d?.orderNotes}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  `;

  const orders = Array.isArray(d) ? d : [d];

  const ordersHtml = orders.map((order, index) => {
    const orderHtml = generateReadyOrderSection(order);
    // Add page break after each order except the last
    if (index < orders.length - 1) {
      return orderHtml + '<div class="pagebreak"></div>';
    }
    return orderHtml;
  }).join("");

  return `
  <!DOCTYPE html>
  <html>
  <head>
    <style>
      body {
        margin: 0;
        padding: 5px;
        box-sizing: border-box;
      }
      .order-section {
        width: 280px;
        margin: 0 auto;
        page-break-inside: avoid;
        break-inside: avoid;
      }
      .order-table {
        width: 280px;
        font-size: 13px;
        text-align: center;
        border-collapse: collapse;
      }
      .order-table th,
      .order-table td {
        text-align: center;
        padding: 2px;
      }
      .last {
        border-bottom: 1px solid black;
        padding-bottom: 5px;
      }
      .pagebreak {
        page-break-before: always;
        break-before: page;
        height: 0;
        margin: 0;
        padding: 0;
        border: 0;
      }
      @media print {
        .order-section {
          page-break-inside: avoid;
          break-inside: avoid;
        }
        .pagebreak {
          page-break-before: always;
          break-before: page;
          height: 0;
          margin: 0;
          padding: 0;
          border: 0;
        }
      }
    </style>
  </head>
  <body>
    ${ordersHtml}
  </body>
  </html>
  `;


}

// export const fxOrderTemplate = (d,) => {
//   console.log(d, "Dattt")

//   return `
//   <!DOCTYPE html>
//   <html>

//   <head>
//     <style>
//       body {
//         margin: 0;
//         padding: 0;
//         box-sizing: border-box;
//       }


//       table {
//         width: 280px;
//         font-size:14px;
//       }
//       .last {
//         border-bottom: 1px solid black;
//         padding-bottom:5px
//     }

//     </style>
//   </head>

//   <body>
//   <div style=marginBottom: 10  />
//   <style>
//       .text-center{
//           text-align:center;  
//           margin-left:100px;
//       }
//   </style>
//   <div className="text-center" >
//     <table className="table" >
//       <thead>
//         <tr class="last">
//           <th colSpan="1" className="text-center">
//             Order # : ${d.code.substring(0, d.code.length - 6)}
//           </th>
//           <th colSpan="3" className="text-center">
//             Party Reference : ${d.orderDetail.partyRef}
//           </th>
//           <th colSpan="1" className="text-center">
//             Brand : ${d.orderDetail.lab}
//           </th>
//         </tr>
//         <hr/>
//       </thead>
//       <tbody>
//       <tr>
//       <th colSpan="6" className="text-center">
//         Date : ${moment(d.createdAt).format("DD/MM/YY")}
//       </th>
//     </tr>
//         <tr>
//           <th colSpan="6" className="text-center">
//             Optician : ${d.party.accountName}
//           </th>
//         </tr>
//         <tr>
//         <th colSpan="6" className="text-center">
//         Customer Name : ${d.isOrderFromApp ? d.orderDetail.customerName : d.orderDetail.clientName}
//       </th>
//         </tr>
//         <tr>
//           <th colSpan="3" className="text-center">
//             Index : ${d.orderDetail.index}
//           </th>
//           <th colSpan="3" className="text-center">
//             Type : ${d.orderDetail.glassType}
//           </th>

//         </tr>
//         <tr class="last">
//         <th colSpan="3" className="text-center">
//         Product : ${d.orderDetail.productName}
//       </th>
//       <th colSpan="3" className="text-center">
//         Coat : ${d.orderDetail.coat}
//       </th>
//         </tr>
//         <hr/>
//         <tr>
//           <th colSpan="1" className="text-center">
//             SIDE
//           </th>
//           <th colSpan="1" className="text-center">
//             SPH
//           </th>
//           <th colSpan="1" className="text-center">
//             CYL
//           </th>
//           <th colSpan="1" className="text-center">
//             AXIS
//           </th>
//           <th colSpan="1" className="text-center">
//             ADD
//           </th>
//         </tr>
//         <tr>
//           <th colSpan="1" className="text-center">
//             R
//           </th>
//           <td colSpan="1" className="text-center"   style="text-align:center;" >
//             ${d.orderDetail.rSph}
//           </td>
//           <td colSpan="1" className="text-center"   style="text-align:center;">
//             ${d.orderDetail.rCyl}
//           </td>
//           <td colSpan="1" className="text-center"   style="text-align:center;">
//             ${d.orderDetail.rAxis}
//           </td>
//           <td colSpan="1" className="text-center"  style="text-align:center;">
//             ${d.orderDetail.rAddition}
//           </td>
//         </tr>
//         <tr class="last">
//           <th colSpan="1" className="text-center">
//             L
//           </th>
//           <td colSpan="1" className="text-center"  style="text-align:center;" >
//             ${d.orderDetail.lSph}
//           </td>
//           <td colSpan="1" className="text-center"   style="text-align:center;">
//             ${d.orderDetail.lCyl}
//           </td>
//           <td colSpan="1" className="text-center"   style="text-align:center;">
//             ${d.orderDetail.lAxis}
//           </td>
//           <td colSpan="1" className="text-center"   style="text-align:center;">
//             ${d.orderDetail.lAddition}
//           </td>
//         </tr>
//         <tr>
//           <th colSpan="3" className="text-center">
//             ED : ${d.orderDetail.ed}
//           </th>
//           <th colSpan="3" className="text-center">
//             PD : ${d.orderDetail.pd}
//           </th>


//         </tr>
//         <tr>
//         <th colSpan="3" className="text-center">
//         PRISM : ${d.orderDetail.prism}
//       </th>
//       <th colSpan="3" className="text-center">
//         DIA : ${d.orderDetail.dia}
//       </th>
//         </tr>
//         <tr>
//         <th colSpan="2" className="text-center">
//         FTH : ${d.orderDetail.fittingHeight}
//       </th>
//           <th colSpan="2" className="text-center">
//             Frame : ${d.orderDetail.frameSection}
//           </th>
//           <th colSpan="2" className="text-center">
//             Pair : ${d.orderDetail.quantity}
//           </th>
//         </tr>
//         <tr>
//           <td colSpan="2" className="text-center">
//             <b>Remark : </b>
//             ${d.orderDetail.note}
//           </td>



//         </tr>
//         <tr >
//         <td colSpan="3" className="text-center">
//         <b>Frame Image : </b>
//         ${d.frameImage !== "" ? "Yes" : "No"}
//         </td>
//         <td colSpan="3" className="text-center">
//         <b>Tint Image : </b>
//         ${d.tintImage !== "" ? "Yes" : "No"}
//       </td>
//         </tr>

//       </tbody>
//     </table>
//     <br />
//     <br />

//   </div>
//   </body>

//   </html>
// `


// }

export const fxOrderTemplate = (data, baseUrl = "") => {
  const orders = Array.isArray(data) ? data : [data];

  const resolveImageUrl = (imageName) => {
    if (!imageName) return null;
    if (imageName.startsWith("http")) {
      return imageName;
    }
    if (imageName.startsWith("/")) {
      return `${baseUrl}${imageName}`;
    }
    return `${baseUrl}/uploads/${imageName}`;
  };

  const renderOrderSection = (order = {}) => {
    const details = order.orderDetail || {};
    const customerName = order.isOrderFromApp ? details.customerName : details.clientName;
    const imageUrl = resolveImageUrl(order.imageName);

    return `
      <div class="order-section">
        <div class="order-content-wrapper">
          ${imageUrl ? `
            <div class="image-wrapper">
              <img src="${imageUrl}" alt="Order Image" class="order-image" crossOrigin="anonymous" />
            </div>
          ` : ""}
          <table class="order-table">
          <thead>
            <tr class="last">
              <th colspan="1">Order #: ${order.code ? order.code.substring(0, order.code.length - 6) : ""}</th>
              <th colspan="3">Party Reference: ${details.partyRef || ""}</th>
              <th colspan="1">Brand: ${details.lab || ""}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th colspan="6">Date: ${order.createdAt ? moment(order.createdAt).format("DD/MM/YY") : ""}</th>
            </tr>
            <tr>
              <th colspan="6">Optician: ${order.party?.accountName || ""}</th>
            </tr>
            <tr>
              <th colspan="6">Customer Name: ${customerName || ""}</th>
            </tr>
            <tr>
              <th colspan="3">Index: ${details.index || ""}</th>
              <th colspan="3">Type: ${details.glassType || ""}</th>
            </tr>
            <tr class="last">
              <th colspan="3">Product: ${details.productName || ""}</th>
              <th colspan="3">Coat: ${details.coat || ""}</th>
            </tr>
            <tr>
              <th>SIDE</th>
              <th>SPH</th>
              <th>CYL</th>
              <th>AXIS</th>
              <th>ADD</th>
            </tr>
            <tr>
              <th>R</th>
              <td>${details.rSph || ""}</td>
              <td>${details.rCyl || ""}</td>
              <td>${details.rAxis || ""}</td>
              <td>${details.rAddition || ""}</td>
            </tr>
            <tr class="last">
              <th>L</th>
              <td>${details.lSph || ""}</td>
              <td>${details.lCyl || ""}</td>
              <td>${details.lAxis || ""}</td>
              <td>${details.lAddition || ""}</td>
            </tr>
            <tr>
              <th colspan="3">ED: ${details.ed || ""}</th>
              <th colspan="3">PD: ${details.pd || ""}</th>
            </tr>
            <tr>
              <th colspan="3">PRISM: ${details.prism || ""}</th>
              <th colspan="3">DIA: ${details.dia || ""}</th>
            </tr>
            <tr>
              <th colspan="2">FTH: ${details.fittingHeight || ""}</th>
              <th colspan="2">Frame: ${details.frameSection || ""}</th>
              <th colspan="2">Pair: ${details.quantity || ""}</th>
            </tr>
            <tr>
              <td colspan="6"><b>Remark:</b> ${details.note || ""}</td>
            </tr>
            <tr>
              <td colspan="3"><b>Frame Image:</b> ${order.frameImage !== "" ? "Yes" : "No"}</td>
              <td colspan="3"><b>Tint Image:</b> ${order.tintImage !== "" ? "Yes" : "No"}</td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
    `;
  };

  return `
  <!DOCTYPE html>
  <html>
    <head>
      <style>
        body {
          margin: 0;
          padding: 10px 12px;
          box-sizing: border-box;
          font-family: "Helvetica", "Arial", sans-serif;
          height: auto;
          min-height: auto;
        }
        .order-section {
          width: 280px;
          margin: 0 auto;
          position: relative;
          page-break-inside: avoid;
          break-inside: avoid;
        }
        .order-content-wrapper {
          display: flex;
          flex-direction: column;
        }
        .order-section:not(:last-child) {
          margin-bottom: 50px;
          padding-bottom: 25px;
        }
        .tear-line {
          width: 100%;
          height: 1px;
          background-color: #999;
          margin: 20px 0;
          opacity: 0.5;
        }
        .order-table {
          width: 100%;
          font-size: 14px;
          border-collapse: collapse;
        }
        .order-table th,
        .order-table td {
          text-align: center;
          padding: 4px;
        }
        .order-table .last {
          border-bottom: 1px solid #000;
          padding-bottom: 5px;
        }
        .order-image {
          max-width: 280px;
          max-height: 200px;
          object-fit: contain;
          border: 1px solid #ccc;
          border-radius: 4px;
          margin-bottom: 10px;
          page-break-inside: avoid;
          break-inside: avoid;
        }
        .image-wrapper {
          text-align: center;
          margin-bottom: 10px;
          page-break-inside: avoid;
          break-inside: avoid;
        }
        /* Continuous printing - no page breaks between orders */
        @media print {
          body {
            margin: 0;
            padding: 10px 12px;
            height: auto;
            min-height: auto;
          }
          .order-section:not(:last-child) {
            margin-bottom: 30px;
            padding-bottom: 15px;
          }
          .tear-line {
            border-top: 1px dashed #999;
            margin: 15px 0;
          }
        }
      </style>
    </head>
    <body>
      ${orders
      .map((order, index) => {
        const orderHtml = renderOrderSection(order);
        // Add tear line between orders for continuous printing
        if (index < orders.length - 1) {
          return orderHtml + '<div class="tear-line"></div>';
        }
        return orderHtml;
      })
      .join("")}
    </body>
  </html>
  `;
};



export const paymentSlipTemplate = (d,) => {
  console.log(d, "Dattt")

  let totalAmountInWords = inWords2(Number(d.amount));
  let amount = 0

  return `
  <!DOCTYPE html>
  <html>
  
  <head>
    <style>
      p {
        font-size:12px;
        line-height:3px;
      }
      table{
        margin:0px;
      }
    </style>  
  </head>
  
  <body>
  <div style="width: 580px; margin: 0 auto; padding: 5px; ">

  <div style="text-align: center;">
    <h3>Payment Receipt - ${d.code}</h3>
    <p>Date: <span>${moment(d.paymentDate).format("LL")}</span></p>
  </div>

  <div>
    <h3>Customer Details:</h3>
    <h4><strong>Name:</strong> ${d.party.name}</h4>
  </div>

  <div>
    <h3>Payment Details:</h3>
    <table style="width: 100%; border-collapse: collapse; ">
      <tr>
        <th style="border: 1px solid #ccc; text-align: left;">Payment Mode</th>
        <th style="border: 1px solid #ccc; text-align: left;">Amount</th>
      </tr>
      ${d.payments.map((m) => {
    amount += Number(m.paymentAmount)
    return (
      `
        <tr>
        <td style="border: 1px solid #ccc;">${m.paymentMode}
        ${m.paymentMode === "Cheque" ? (
        `
          <br/>
          <p>Cheque Number - ${m.chequeNo}</p>
          <p>Bank Name - ${m.bankName}</p>
          <p>Branch Name - ${m.branchName}</p>
          `
      ) : ''}
        </td>
        <td style="border: 1px solid #ccc;">${m.paymentAmount}</td>
        </tr>
        `
    )
  })}

      <tr>
        <td style="border: 1px solid #ccc; "><strong>Total</strong></td>
        <td style="border: 1px solid #ccc; "><strong>${amount}</strong></td>
      </tr>
    </table>
    <h4>Total Amount in words : ${inWords2(amount)}</h4>
    <div style="display:flex; flex-direction:row;justify-content:space-between ; padding-horizontal:50px">
    <h5 style="width:200px;">Note <br/> ${d.paymentDetails} </h5>
    <h5>Signature :</h5>
    </div>
  </div>

</div>

  </body>
  
  </html>
`


}